/** Figma reference width — all proportional dimensions derive from this. */
export const REFERENCE_WIDTH = 810;

/** Vertical boost — increases widget height by 15% over the base Figma ratio. */
export const HEIGHT_BOOST = 1.15;

/**
 * Fixed landscape banner ratio for the real-estate listing-page widget, the ONE
 * surface that crops banners (so every card in the rack aligns). Everywhere else
 * the banner keeps its natural ratio. Shared by the owner `SeriesCard`
 * (edit/preview) and the public `RealEstateVideoSeriesRack` so the three modes
 * can't drift apart.
 */
export const REALESTATE_BANNER_ASPECT_RATIO = 5 / HEIGHT_BOOST;

export interface SeriesContentMetrics {
  gap: number;
  cols: number;
  itemWidth: number;
  itemHeight: number;
}

/** Compute series grid layout metrics scaled proportionally from the Figma reference. */
export function computeSeriesContentMetrics(
  containerWidth: number,
): SeriesContentMetrics {
  if (containerWidth <= 0) {
    return { gap: 8, cols: 3, itemWidth: 78, itemHeight: 98 };
  }
  const scale = containerWidth / REFERENCE_WIDTH;
  const mobileBoost = containerWidth < 480 ? 1.5 : 1;
  const itemDesignWidth = Math.round(110 * scale * mobileBoost);
  const gap = Math.max(4, Math.round(12 * scale));
  const cols =
    Math.max(1, Math.floor((containerWidth + gap) / (itemDesignWidth + gap))) +
    0.5;
  const itemWidth = Math.round((containerWidth + gap) / cols - gap);
  const itemHeight = Math.round(itemWidth * (3 / 2));

  return {
    gap,
    cols: Math.round(cols),
    itemWidth,
    itemHeight,
  };
}
